export const HTTP_STATUS_CODE = Object.freeze({
  CONFLICT: 409,
  FORBIDDEN: 403,
  MULTI_STATUS: 207,
  NOT_ACCEPTABLE: 406,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  SUCCESS:200,
});

export const getStatusFromResponseIfExists = (response) => {
  if (response && response.status){
    return response.status;
  }

  return -1;
};

export const validate = (value, rules) => {
  const approve = require('approvejs'); // eslint-disable-line no-undef
  const result = approve.value(value, rules);
  if (!result.approved){
    throw Error(result.errors);
  }
};
